import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from "react";
import { useBranding } from "../BrandingProvider/BrandingProvider";
import { DEFAULT_MASK } from "../PostalCodeTextMask/usePostalCodeTextMask";
import Loading from "../loading";
import { GetCompanyProviderModel } from "./CompanyProvider.request";
export const CompanyProvider = ({ children }) => {
    var _a, _b, _c;
    const { data, loading, error, tokenMap } = GetCompanyProviderModel();
    const { branding } = useBranding();
    if (loading || !data)
        return _jsx(Loading, { viewportHeight: "75vh" });
    if (error) {
        return _jsx(Loading, { error: true, text: error, viewportHeight: "75vh" });
    }
    //If Brand URL is set, use it. otherwise, use company config website.
    let homeUrl = ((_b = (_a = branding.BrandURL) === null || _a === void 0 ? void 0 : _a.Input) === null || _b === void 0 ? void 0 : _b.length) > 0 ? (_c = branding.BrandURL) === null || _c === void 0 ? void 0 : _c.Input : data.website;
    if (homeUrl && (homeUrl === null || homeUrl === void 0 ? void 0 : homeUrl.length) > 0) {
        //Append protocol if not present, assume SSL.
        homeUrl = (homeUrl === null || homeUrl === void 0 ? void 0 : homeUrl.indexOf("http")) === -1 ? `https://${homeUrl}` : homeUrl;
    }
    else {
        homeUrl = undefined;
    }
    const value = {
        culture: {
            cultureInfo: data.cultureInfo,
            currency: data.currencyType,
            countryCode: data.countryCode,
        },
        keys: data.keys,
        imgBaseUrl: data.imgBaseUrl,
        buildVersion: data.buildVersion,
        name: data.name,
        displayName: branding.BrandDisplayName.Input.length !== 0 ? branding.BrandDisplayName.Input : data.name,
        url: homeUrl,
        doesCompanyHaveOrderPage: data.doesCompanyHaveOrderPage,
        navOrderButtonText: data.navOrderButtonText,
        orderNowLink: data.orderNowLink,
        companyUsesKlaviyo: data.companyUsesKlaviyo,
        companyUsesSMS: data.companyUsesSMS,
        postalCodeMasks: data.postalCodeMasks,
        openedFromMobileApp: data.openedFromMobileApp,
        mobileRedirectFailureUrl: data.mobileRedirectFailureUrl,
        mobileRedirectSuccessUrl: data.mobileRedirectSuccessUrl,
        footerAttributionMD: data.footerAttributionMD,
        companyText: data.companyText,
        tokenMap: tokenMap,
        companySettingsCountry: data.companySettingsCountry,
    };
    return _jsx(CompanyContext.Provider, Object.assign({ value: value }, { children: children }));
};
export const CompanyContext = React.createContext({
    culture: {
        cultureInfo: "",
        currency: "",
        countryCode: "",
    },
    keys: [],
    displayName: "",
    name: "",
    url: "",
    imgBaseUrl: "",
    buildVersion: "",
    doesCompanyHaveOrderPage: false,
    navOrderButtonText: "Order Now",
    orderNowLink: "",
    postalCodeMasks: DEFAULT_MASK,
    companyUsesKlaviyo: false,
    companyUsesSMS: false,
    openedFromMobileApp: false,
    footerAttributionMD: "[Meal Delivery Software By MealTrack](https://mealtrack.com/?utm_campaign=AppReferral&utm_source=MT&utm_medium={CompanyName})",
    companyText: [],
    tokenMap: new Map(),
    companySettingsCountry: "",
});
export const useCompany = () => useContext(CompanyContext);
